import instance from 'api';
import { IPersonalRatingRequest } from '../../interfaces';

export const savePersonalRating = (personalRatings: IPersonalRatingRequest[]) => {
  return instance()
    .post(`/realEstate/personal/rating/listSave`, personalRatings)
    .then((response) => response.data);
};
